import React, { useState, useContext, useEffect } from 'react';
import axios from "../../../../axios/index"
import Modal from 'react-bootstrap/Modal';

import { UserContext } from '../../../Context/UserContextProvider';

// ModalStyles
import styles from "./../StaffManagment.module.css";
import ModalStyles from "./../../DashboardReuseAbleComponents/Modal.module.css"

const ModalLimitFiles = (props) => {
    const { userToken } = useContext(UserContext);
    const [btnLoader, setBtnLoader] = useState(false)
    const [countModalLimitFiles, setCountModalLimitFiles] = useState(50);

    const incrementCountLimitHandler = () => setCountModalLimitFiles(prevState => prevState + 1)

    const decreaseCountLimitHandler = () => countModalLimitFiles > 0 ? setCountModalLimitFiles(prevState => prevState - 1) : 0

    const e2p = s => s?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])

    useEffect(() => {
        const getData = async () => {
            const apiData = await axios.get(
                "Consultant/AccessibleFileCount",
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            setCountModalLimitFiles(apiData.data.data.count)
        }
        getData()
    }, [userToken])

    return (
        <>
            <style type="text/css">
                {`
                .modal {
                    background: #3335;
                }

                .modal-content {
                    width: 870px;
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }
            `}
            </style>

            <Modal
                show={props.show}
                onHide={props.onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton dir='rtl'>
                    <div className='w-100 d-flex align-items-start justify-content-between px-3'>
                        <div className={ModalStyles.title}>
                            فایل های مجاز
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body dir="rtl" className={`my-3`}>
                    <div className={`w-50 mx-auto px-3 text-center ${styles.total_modal_body_files_box}`}>
                        <h3 className={`${styles.title_modal_body_files_box}`}> تعیین تعداد فایل های مجاز </h3>
                        <p className={`mt-3 mb-4 ${styles.text_modal_body_files_box}`}>
                            با تعیین تعداد فایل های مجاز هر مشاور فقط به همان
                            تعداد از فایل در روز میتواند دسترسی داشته باشد
                        </p>
                        <div className={`${styles.total_counts_modal_body_files_box}`}>
                            <p className={`mb-2 text-right ${styles.title_counts_modal_body_files_box}`}> انتخاب تعداد </p>
                            <div className={`w-100 d-flex align-items-center justify-content-center ${styles.total_form_counts_modal_body_files_box}`}>
                                <span className={`${styles.plus_counts_modal_body_files_box}`} role="button" onClick={incrementCountLimitHandler}> + </span>
                                <span className={`px-5 ${styles.number_counts_modal_body_files_box}`}> {e2p(countModalLimitFiles?.toString())} </span>
                                <span className={`${styles.minus_counts_modal_body_files_box}`} role="button" onClick={decreaseCountLimitHandler}> - </span>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='w-100 d-flex justify-content-center align-items-center mb-3'>
                        {btnLoader ? (
                            <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`} >
                                <div className={ModalStyles.btn_loader_container}>
                                    <div className={ModalStyles.btn_spinner}></div>
                                </div>
                            </div>
                        )
                            : (
                                <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`} onClick={limitHandler}>
                                    ثبت
                                </div>
                            )
                        }
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );

    async function limitHandler() {
        setBtnLoader(true)
        var data = new FormData();
        data.append('Title', countModalLimitFiles);
        const apiData = await axios.post(
            `Consultant/ShowFileLimit?count=${countModalLimitFiles}`,
            {
                headers: { authorization: "Bearer " + userToken },
            }
        );
        // console.log(apiData)
        setBtnLoader(false)
        props.onHide()
        window.location.reload(false)

    }
};

export default ModalLimitFiles;